import React from "react";
import PropTypes from "prop-types";
import { Link as GatsbyLink } from "gatsby";
import { resolve } from "styled-jsx/css";
import { useTheme } from "./theme";
import { IconButton } from "./Button";

const getLinkStyle = ({ linkTextColor }) => resolve`
    color: ${linkTextColor};

    :focus {
        outline: 0;
        border-bottom: 1px solid;
    }
    :hover {
        border-bottom: 1px solid;
    }
`;

export function Link({ to, defaultLink, className = "", children, ...rest }) {
    const isInternal = /^\/(?!\/)/.test(to) && !defaultLink;
    const { className: linkClassName, styles } = getLinkStyle(useTheme());
    const classes = `${linkClassName} ${className}`;
    return (
        <>
            {isInternal ? (
                <GatsbyLink
                    to={to}
                    className={classes}
                    {...rest}
                    onClick={(e) => e.stopPropagation()}
                >
                    {children}
                </GatsbyLink>
            ) : (
                <a
                    href={to}
                    className={classes}
                    {...rest}
                    onClick={(e) => e.stopPropagation()}
                >
                    {children}
                </a>
            )}
            {styles}
        </>
    );
}

Link.propTypes = {
    to: PropTypes.string.isRequired,
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
};

Link.defaultProps = {
    className: "",
};

const getBtnLinkStyle = ({ linkTextColor }) => resolve`
    display: inline-block;
    font-weight: 600;
    padding: 0.5em 3em;
    border-radius: 10px;
    border: 2px solid ${linkTextColor};

    :focus,
    :active {
        outline: 0;
        background-color: ${linkTextColor};
        color: #fff;
    }

    :hover {
        background-color: ${linkTextColor};
        color: #fff;
    }

    :focus,
    :hover,
    :active {
        border: 2px solid ${linkTextColor};
    }
`;

export function ButtonLink({ className = "", ...rest }) {
    const {
        className: btnLinkClassName,
        styles: btnLinkStyles,
    } = getBtnLinkStyle(useTheme());
    return (
        <>
            <Link className={`${btnLinkClassName} ${className}`} {...rest} />
            {btnLinkStyles}
        </>
    );
}

const {
    className: iconLinkButtonClassName,
    styles: iconLinkButtonStyles,
} = resolve`
    display: flex;
    align-items: center;
    justify-content: center;
`;
export function IconButtonLink({ className = "", children, ...rest }) {
    // Looks like a button so should work like a button too i.e. activated on
    // Space? But what about those who use Space to scroll and see that it's an
    // anchor tag and accidentally activate it? Cannot decide so do nothing
    return (
        <IconButton
            as={Link}
            className={`${iconLinkButtonClassName} ${className}`}
            {...rest}
        >
            {children}
            {iconLinkButtonStyles}
        </IconButton>
    );
}
